import { useState } from 'react';

import useWorkspaceStorage from '@/hooks/pure/useWorkspaceStorage';
import { INITIAL_FILTER_SET_QUERY } from '@/types/dataTableConst';
import filterUtils from '@/utils/filter';

const useFilterQuery = (
  callbacks?: {
    onFilterChangeCallback?: (filterSetQuery: FilterSetQuery) => void;
    clearFilterCallback?: () => void;
  },
  initialFilterSetQuery?: FilterSetQuery,
): {
  currFilterSetQuery: FilterSetQuery;
  onFilterSetChange: (value: FilterSetQuery) => void;
  onFilterChange: (filterQueryFormat: FilterQueryFormatT) => void;
  clearFilter: () => void;
} => {
  const [currFilterSetQuery, setFilterSetQuery] = useState(
    initialFilterSetQuery || INITIAL_FILTER_SET_QUERY,
  );

  const clearFilter = () => {
    setFilterSetQuery(INITIAL_FILTER_SET_QUERY);
  };

  const onFilterChange = (filterQueryFormat: FilterQueryFormatT) => {
    const newFilterSetQuery = filterUtils.updateFilterQueryFormats(
      currFilterSetQuery,
      filterQueryFormat,
    );

    setFilterSetQuery(newFilterSetQuery);
    callbacks?.onFilterChangeCallback?.(newFilterSetQuery);
  };

  const onFilterSetChange = (filterSetQuery: FilterSetQuery) => {
    setFilterSetQuery(filterSetQuery);
    callbacks?.onFilterChangeCallback?.(filterSetQuery);
  };

  const onClearFilter = () => {
    clearFilter();
    callbacks?.clearFilterCallback?.();
  };

  return {
    currFilterSetQuery,
    onFilterSetChange,
    onFilterChange,
    clearFilter: onClearFilter,
  };
};

export default useFilterQuery;

const useStorageFilterQuery = (
  storageKey: string,
  callbacks?: {
    onFilterChangeCallback?: (filterSetQuery: FilterSetQuery) => void;
    clearFilterCallback?: () => void;
  },
): {
  currFilterSetQuery: FilterSetQuery;
  onFilterSetChange: (value: FilterSetQuery) => void;
  onFilterChange: (filterQueryFormat: FilterQueryFormatT) => void;
  clearFilter: () => void;
} => {
  const [currFilterSetQuery, setFilterSetQuery, clearFilter] =
    useWorkspaceStorage(storageKey, INITIAL_FILTER_SET_QUERY);

  const onFilterChange = (filterQueryFormat: FilterQueryFormatT) => {
    const newFilterSetQuery = filterUtils.updateFilterQueryFormats(
      currFilterSetQuery,
      filterQueryFormat,
    );

    setFilterSetQuery(newFilterSetQuery);
    callbacks?.onFilterChangeCallback?.(newFilterSetQuery);
  };

  const onFilterSetChange = (filterSetQuery: FilterSetQuery) => {
    setFilterSetQuery(filterSetQuery);
    callbacks?.onFilterChangeCallback?.(filterSetQuery);
  };

  const onClearFilter = () => {
    clearFilter();
    callbacks?.clearFilterCallback?.();
  };

  return {
    currFilterSetQuery,
    onFilterSetChange,
    onFilterChange,
    clearFilter: onClearFilter,
  };
};

export { useStorageFilterQuery };
